/* ==========================================================================
   MOBRIO — Selector de color funcional en la product card.

   Estructura real de los productos (verificada en la tienda):
   - 2 opciones de variante: "Color" x "Compatibilidad por modelo".
     => un color = varias variantes (una por modelo).
   - Los swatches nativos viven en el valor de opción (shopify--color-pattern):
     option value .swatch.color / .swatch.image  -> los pinta card-meta.liquid.
   - Cada color tiene su propia imagen de variante (todos los modelos de un
     color comparten imagen). El precio es uniforme entre colores.

   card-meta.liquid deja en cada botón de color la VARIANTE REAL representativa:
     data-color-name, data-variant-id, data-variant-url (?variant=ID),
     data-variant-available, data-color-image.

   Al seleccionar un color (clic o teclado, escritorio y móvil):
     1. se marca el color (estado + aria-pressed);
     2. se localiza su variante real (ya viene en el botón, sin IDs hardcodeados);
     3. se cambia la imagen de la card a la de esa variante (si tiene una propia);
     4. se actualiza el enlace de la card a esa variante (?variant=ID), de modo
        que al entrar al producto se abre ya en ese color.
   El precio no cambia porque es uniforme entre colores (si algún día difiere,
   basta con añadir data-variant-price y actualizar aquí el nodo .price).

   No navega al pulsar el swatch: el botón es hermano del enlace de la card, no
   está anidado en él, así que su clic no dispara la navegación (sin necesidad de
   stopPropagation). Resistente al re-render AJAX de la colección (delegación +
   MutationObserver). Sin librerías.
   ========================================================================== */
(function () {
  'use strict';

  function cardImgs(card) {
    // TODAS las imágenes del media: en escritorio Dawn muestra la 2ª imagen al
    // pasar el ratón (media--hover-effect). Si sólo cambiáramos la 1ª, en desktop
    // no se vería el cambio de color mientras el cursor está sobre la card.
    var media = card.querySelector('.card__media') || card;
    return media.querySelectorAll('img');
  }

  function swapImage(card, url) {
    if (!card || !url) return;
    var imgs = cardImgs(card);
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (!img.dataset.mobrioOrigSrc) {
        img.dataset.mobrioOrigSrc = img.getAttribute('src') || '';
        img.dataset.mobrioOrigSrcset = img.getAttribute('srcset') || '';
      }
      // El srcset ganaría al src; lo vaciamos para forzar la imagen elegida.
      img.setAttribute('srcset', '');
      img.setAttribute('src', url);
    }
  }

  function restoreImage(card) {
    var imgs = cardImgs(card);
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (!img.dataset.mobrioOrigSrc) continue;
      img.setAttribute('src', img.dataset.mobrioOrigSrc);
      img.setAttribute('srcset', img.dataset.mobrioOrigSrcset || '');
    }
  }

  // Actualiza los enlaces de la card (imagen + título) a la variante elegida.
  function updateLinks(card, url) {
    if (!card || !url) return;
    var links = card.querySelectorAll('.card__full-link, .card__title-row .card__heading a');
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('href', url);
    }
  }

  function setActive(card, btn) {
    var all = card.querySelectorAll('.card__color-btn');
    for (var i = 0; i < all.length; i++) {
      var isBtn = all[i] === btn;
      all[i].classList.toggle('is-active', isBtn);
      all[i].setAttribute('aria-pressed', isBtn ? 'true' : 'false');
    }
  }

  // Aplica una variante de color a la card (imagen + enlace + estado).
  function selectColor(card, btn) {
    if (!card || !btn) return;
    swapImage(card, btn.getAttribute('data-color-image'));
    updateLinks(card, btn.getAttribute('data-variant-url'));
    setActive(card, btn);
  }

  // --- Interacción directa: pulsar un color aplica su variante -----------------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.card__color-btn');
    if (!btn) return;
    var card = btn.closest('.card-wrapper');
    if (!card) return;
    selectColor(card, btn);
  });

  // Teclado: Enter/Espacio sobre un <button> ya emite 'click' de forma nativa,
  // por lo que el manejador anterior cubre la navegación por teclado.

  // Hover (solo puntero fino): previsualiza el color sin fijarlo.
  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mouseover', function (e) {
      var btn = e.target.closest('.card__color-btn');
      if (!btn) return;
      var card = btn.closest('.card-wrapper');
      if (card) swapImage(card, btn.getAttribute('data-color-image'));
    });
    document.addEventListener('mouseout', function (e) {
      var btn = e.target.closest('.card__color-btn');
      if (!btn) return;
      var card = btn.closest('.card-wrapper');
      if (!card) return;
      // Si hay un color fijado (activo por clic o filtro), volvemos a él.
      var active = card.querySelector('.card__color-btn.is-active');
      if (active) { swapImage(card, active.getAttribute('data-color-image')); }
      else { restoreImage(card); }
    });
  }

  // --- Filtro por color: aplicar la variante correspondiente en cada card -----
  function activeColorValues() {
    var out = [];
    try {
      var params = new URLSearchParams(window.location.search);
      params.forEach(function (val, key) {
        var k = key.toLowerCase();
        if (k.indexOf('filter.v.option.color') === 0 || (k.indexOf('filter.') === 0 && k.indexOf('color') > -1)) {
          out.push(String(val).toLowerCase());
        }
      });
    } catch (err) { /* no-op */ }
    return out;
  }

  function applyActiveColor(root) {
    root = root || document;
    var active = activeColorValues();
    if (!active.length) return;
    var cards = root.querySelectorAll('.card-wrapper');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var btns = card.querySelectorAll('.card__color-btn');
      for (var j = 0; j < btns.length; j++) {
        var name = (btns[j].getAttribute('data-color-name') || '').toLowerCase();
        if (active.indexOf(name) > -1) { selectColor(card, btns[j]); break; }
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () { applyActiveColor(); });
  window.addEventListener('pageshow', function () { applyActiveColor(); });

  // Dawn reemplaza #product-grid al filtrar/ordenar/paginar (AJAX). Observamos
  // su contenedor para reaplicar el color activo sobre las cards nuevas.
  function observeGrid() {
    if (!window.MutationObserver) return;
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    var pending = null;
    var mo = new MutationObserver(function () {
      window.clearTimeout(pending);
      pending = window.setTimeout(function () { applyActiveColor(); }, 60);
    });
    mo.observe(container, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') { observeGrid(); }
  else { document.addEventListener('DOMContentLoaded', observeGrid); }
})();